import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

export const useLabelStore = defineStore('label', () => {
    const senseDataUrl = ref()
    const labelData = ref()
    const labelInDatabase = ref()
    const isLabelTap = ref(false)

    const labelStatuses = computed(() => {
        return labelData.value?.calculatedSenseData?.statuses
    })

    const labelIsConfigured = computed(() => {
        // Label report is present
        if (labelData.value?.id) return true
        // Label has configured status
        if (labelStatuses.value?.includes('CONFIGURED')) return true
        return false
    })

    const labelIsActive = computed(() => {
        if (!labelStatuses.value?.includes('CONFIGURED') || labelHasStopped.value) return false
        if (labelStatuses.value?.includes('STARTING')) return true
        return false
    })

    const labelHasStopped = computed(() => {
        if (labelStatuses.value?.includes('STOPPED')) return true
        if (labelStatuses.value?.includes('EXPIRED')) return true
        return false
    })

    const labelHasError = computed(() => {
        if (labelStatuses.value?.includes('UNEXPECTED_STOP')) return true
        if (labelStatuses.value?.includes('SPI_ERROR')) return true
        if (labelStatuses.value?.includes('I2C_ERROR')) return true
        return false
    })

    const labelHasViolations = computed(() => {
        if (labelStatuses.value?.includes('TEMPERATURE_TOO_LOW') || labelStatuses.value?.includes('TEMPERATURE_TOO_HIGH')) return true
        if (labelStatuses.value?.includes('HUMIDITY_TOO_LOW') || labelStatuses.value?.includes('HUMIDITY_TOO_HIGH')) return true
        return false
    })

    const statusString = computed(() => {
        if (labelStatuses.value?.includes('EXPIRED')) return 'Label has finished measuring'
        if (labelStatuses.value?.includes('BOD')) return 'Battery is drained'
        if (labelStatuses.value?.includes('FULL')) return `Label's memory is full`
        if (labelHasError.value && labelStatuses.value?.includes('STOPPED')) return 'Label had an error'
        if (labelStatuses.value?.includes('STOPPED')) return 'Label has stopped measuring'
        if (labelStatuses.value?.includes('LOGGING')) return 'Label is currently measuring'
        if (labelStatuses.value?.includes('STARTING')) return 'Label will start measuring'
        if (labelStatuses.value?.includes('CONFIGURED')) return 'Label is configured'

        return 'Label has not been configured'
    })

    const statusStringShort = computed(() => {
        if (labelStatuses.value?.includes('EXPIRED')) return 'Finished'
        if (labelStatuses.value?.includes('BOD')) return 'Battery drained'
        if (labelStatuses.value?.includes('FULL')) return `Memory full`
        if (labelHasError.value && labelStatuses.value?.includes('STOPPED')) return 'Error occurred'
        if (labelStatuses.value?.includes('STOPPED')) return 'Stopped'
        if (labelStatuses.value?.includes('LOGGING')) return 'Measuring'
        if (labelStatuses.value?.includes('STARTING')) return 'Starting'
        if (labelStatuses.value?.includes('CONFIGURED')) return 'Configured'

        return 'Not configured'
    })

    const batteryStatusString = computed(() => {
        if (labelStatuses.value?.includes('BOD')) return 'Drained'
        else return 'OK'
    })

    const labelHasReadAccessToken = computed(() => {
        if (labelData.value?.readAccessToken) return true
        return false
    })

    return {
        senseDataUrl,
        labelData,
        labelInDatabase,
        isLabelTap,
        labelIsConfigured,
        labelIsActive,
        labelHasStopped,
        labelHasError,
        labelHasViolations,
        statusString,
        statusStringShort,
        batteryStatusString,
        labelHasReadAccessToken
    }
})
